<div class="header">
	<div class="filter">
		{{ 'SHOW' | translate | lowercase }}
	
		<bb-select [(ngModel)]="filter" (ngModelChange)="filterChanged()">
			<option value="all">{{ 'ALL' | translate | lowercase }}</option>
			<option value="new">{{ 'NEW' | translate | lowercase }}</option>
			<option value="queued">{{ 'QUEUED' | translate | lowercase }}</option>
			<option value="failed">{{ 'FAILED' | translate | lowercase }}</option>
			<option value="exported">{{ 'EXPORTED' | translate | lowercase }}</option>
		</bb-select>
	
		{{ 'CLIPS' | translate | lowercase }}
	</div>
</div>

<bb-table-container class="socials-theme" *ngIf="(rows && rows.length)">
	<caption>
		{{ 'SYNCHRONISED_CLIPS' | translate }}
	</caption>
	<bb-table-header >
		<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
		<bb-table-header-cell property="title">{{ 'TITLE' | translate }}</bb-table-header-cell>
		<bb-table-header-cell property="status">{{ 'STATUS' | translate }}</bb-table-header-cell>
		
	</bb-table-header>

	<bb-table-row *ngFor="let row of rows" [row]="row" (dblclick)="redirectToMediaclip(row.data)">
		<bb-table-cell property="id">{{ row.data.id }}</bb-table-cell>
		<bb-table-cell proptery="title"><span [innerHTML]="row.data | clipTitle"></span></bb-table-cell>
		<bb-table-cell property="status">
			<span [hidden]="row.data.Facebook_status" class="gray status-new" [innerHTML]="row.data | statusIcon:'social-export'"></span>
			<span [hidden]="row.data.Facebook_status !== 'new'" class="orange status-queued" [innerHTML]="row.data | statusIcon:'social-export'"></span>
			<span [hidden]="row.data.Facebook_status !== 'error'" class="red status-failed" [innerHTML]="row.data | statusIcon:'social-export'"></span>
			<span [hidden]="row.data.Facebook_status !== 'exported'" class="green status-exported" [innerHTML]="row.data | statusIcon:'social-export'"></span>
		</bb-table-cell>
	</bb-table-row>

</bb-table-container>

<bb-table-pager *ngIf="(rows && rows.length)" theme="socials-theme"></bb-table-pager>

<div *ngIf="(channel && !channel.id) || (rows && !rows.length)" class="placeholder-empty">
	<div class="placeholder-empty-image">
		<div class="block">
			<i class="fa-regular fa-film-slash"></i>
		</div>
		<span class="placeholder-text">{{ 'NO_MEDIA_CLIPS_SYNCHRONIZED' | translate }}</span>
		<a class="placeholder-text blue" [routerLink]="['/library/mediaclips']">{{ 'CLICK_HERE_TO_SYNCHRONIZE' | translate }}</a>
	</div>
</div>

<bb-entity-details [entity]="channel"></bb-entity-details>
